import { Button, useModal } from '@payloadcms/ui';

import { CREATE_NEW_LANDING_MODAL_SLUG } from '../CreateNewLandingModal';

interface ConfirmLandingCreationProps {
  onContinue: () => void;
}

export const ConfirmLandingCreation = ({ onContinue }: ConfirmLandingCreationProps) => {
  const { closeModal } = useModal();

  return (
    <div data-testid="create-new-landing-step-intro">
      <h2>Are you sure you want to create a new landing?</h2>
      <p>This action will trigger different processes to create the landing in the system.</p>
      <div className="fv-create-new-landing-modal__step-actions">
        <Button
          type="button"
          buttonStyle="primary"
          icon="plus"
          onClick={onContinue}
          extraButtonProps={{ 'data-testid': 'create-new-landing-intro-continue' }}
        >
          Yes, I am sure.
        </Button>
        <Button
          type="button"
          buttonStyle="secondary"
          icon="x"
          onClick={() => closeModal(CREATE_NEW_LANDING_MODAL_SLUG)}
          extraButtonProps={{ 'data-testid': 'create-new-landing-intro-cancel' }}
        >
          No
        </Button>
      </div>
    </div>
  );
};
